import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BookingProvider } from './components/BookingContext';
import { BookingExperience } from './components/BookingExperience';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { AmbientBackground } from './components/AmbientBackground';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { HospitalityPage } from './pages/HospitalityPage';
import { ConveyancingPage } from './pages/ConveyancingPage';
import { FieldServicesPage } from './pages/FieldServicesPage';
import { LogisticsPage } from './pages/LogisticsPage';
import { MaritimePage } from './pages/MaritimePage';
import { RenewablesPage } from './pages/RenewablesPage';
import { IndustryPlaceholder } from './pages/IndustryPlaceholder';
import { SitemapXml } from './pages/SitemapXml';
import { TermsAndConditions } from './pages/TermsAndConditions';
export function App() {
  return <BookingProvider data-id="element-0">
      <div className="relative min-h-screen bg-brand-black text-white selection:bg-brand-orange/30" data-id="element-1">
        <AmbientBackground data-id="element-2" />
        <Navbar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-8" />} data-id="element-7" />
          <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-10" />} data-id="element-9" />
          <Route path="/industries/hospitality" element={<HospitalityPage data-id="element-12" />} data-id="element-11" />
          <Route path="/industries/conveyancing" element={<ConveyancingPage data-id="element-14" />} data-id="element-13" />
          <Route path="/industries/field-services" element={<FieldServicesPage data-id="element-16" />} data-id="element-15" />
          <Route path="/industries/logistics" element={<LogisticsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/industries/maritime" element={<MaritimePage data-id="element-20" />} data-id="element-19" />
          <Route path="/industries/renewables" element={<RenewablesPage data-id="element-22" />} data-id="element-21" />
          <Route path="/industries/:slug" element={<IndustryPlaceholder data-id="element-24" />} data-id="element-23" />
        </Routes>
        <Footer data-id="element-25" />
        <BookingExperience data-id="element-26" />
      </div>
    </BookingProvider>;
}